__webpack_require__.p = "/digisg/foreign-exchange/";